// extracted by mini-css-extract-plugin
export default {"layoutFooter":"Footer_layoutFooter__GRlAu"};